import { useTranslation } from 'react-i18next';

// Product translation mapping
export const PRODUCT_TRANSLATION_KEYS: Record<string, string> = {
  // Heritage Products
  "Aunt Mollys Ground Cherry": "products.heritage.auntMollysGroundCherry",
  "Bean Gold Rush": "products.heritage.beanGoldRush",
  "Bean Golden Wax Bush": "products.heritage.beanGoldenWaxBush",
  "Bean Kentucky Wonder (Pole) -H": "products.heritage.beanKentuckyWonderPole",
  "Bean Provider Bush": "products.heritage.beanProviderBush",
  "Bean Tendergreen Improved - H": "products.heritage.beanTendergreenImproved",
  "Beet Cylindra": "products.heritage.beetCylindra",
  "Beet Detroit Dark Red - H": "products.heritage.beetDetroitDarkRed",
  "Beet Early Wonder Tall Top - H": "products.heritage.beetEarlyWonderTallTop",
  "Beet Green Top Bunching": "products.heritage.beetGreenTopBunching",
  "Radish Cherry Belle ST - H": "products.heritage.radishCherryBelleST",
  "Radish French Breakfast ST - H": "products.heritage.radishFrenchBreakfastST",
  "Bean Blue Lake Pole": "products.heritage.beanBlueLakePole",
  "Bean Improved Golden Wax Bush": "products.heritage.beanImprovedGoldenWaxBush",
  "Bean Kentucky Wonder Bush": "products.heritage.beanKentuckyWonderBush",
  "Bean Pole Blue Lake": "products.heritage.beanPoleBlueLake",
  "Bean Tendergreen Bush": "products.heritage.beanTendergreenBush",
  "Beet Detroit Dark Red": "products.heritage.beetDetroitDarkRedHeritage",
  "Beet Early Wonder": "products.heritage.beetEarlyWonderHeritage",
  "Beet Golden": "products.heritage.beetGoldenHeritage",
  "Beet Red Ace": "products.heritage.beetRedAce",
  "Broccoli Calabrese": "products.heritage.broccoliCalabrese",
  "Broccoli De Cicco": "products.heritage.broccoliDeCicco",
  "Cabbage Golden Acre": "products.heritage.cabbageGoldenAcre",
  "Cabbage Red Acre": "products.heritage.cabbageRedAcre",
  "Carrot Danvers Half Long": "products.heritage.carrotDanversHalfLong",
  "Carrot Nantes Coreless": "products.heritage.carrotNantesCoreless",
  "Carrot Scarlet Nantes": "products.heritage.carrotScarletNantes",
  "Cauliflower Snowball": "products.heritage.cauliflowerSnowball",
  "Corn Golden Bantam": "products.heritage.cornGoldenBantam",
  "Corn Silver Queen": "products.heritage.cornSilverQueen",
  "Cucumber Bush Pickle": "products.heritage.cucumberBushPickle",
  "Cucumber Marketmore": "products.heritage.cucumberMarketmore",
  "Lettuce Buttercrunch": "products.heritage.lettuceButtercrunch",
  "Lettuce Iceberg": "products.heritage.lettuceIceberg",
  "Lettuce Romaine": "products.heritage.lettuceRomaine",
  "Onion Yellow Spanish": "products.heritage.onionYellowSpanish",
  "Pepper Bell California Wonder": "products.heritage.pepperBellCaliforniaWonder",
  "Pepper Bell Red": "products.heritage.pepperBellRed",
  "Spinach Bloomsdale": "products.heritage.spinachBloomsdale",
  "Squash Acorn": "products.heritage.squashAcorn",
  "Squash Butternut": "products.heritage.squashButternut",
  "Tomato Beefsteak": "products.heritage.tomatoBeefsteak",
  "Tomato Cherry": "products.heritage.tomatoCherry",
  "Tomato Roma": "products.heritage.tomatoRoma",

  // Livingston Products
  "Tomato Beefsteak Livingston": "products.livingston.tomatoBeefsteakLivingston",
  "Tomato Cherry Livingston": "products.livingston.tomatoCherryLivingston",
  "Tomato Roma Livingston": "products.livingston.tomatoRomaLivingston",
  "Pepper Bell Red Livingston": "products.livingston.pepperBellRedLivingston",
  "Pepper Bell Yellow Livingston": "products.livingston.pepperBellYellowLivingston",
  "Pepper Bell Green Livingston": "products.livingston.pepperBellGreenLivingston",
  "Cucumber Marketmore Livingston": "products.livingston.cucumberMarketmoreLivingston",
  "Cucumber Bush Pickle Livingston": "products.livingston.cucumberBushPickleLivingston",
  "Corn Golden Bantam Livingston": "products.livingston.cornGoldenBantamLivingston",
  "Corn Silver Queen Livingston": "products.livingston.cornSilverQueenLivingston",
  "Bean Bush Blue Lake Livingston": "products.livingston.beanBushBlueLake",
  "Bean Pole Kentucky Wonder Livingston": "products.livingston.beanPoleKentuckyWonder",
  "Carrot Danvers Half Long Livingston": "products.livingston.carrotDanversHalfLongLivingston",
  "Carrot Nantes Coreless Livingston": "products.livingston.carrotNantesCorelessLivingston",
  "Lettuce Buttercrunch Livingston": "products.livingston.lettuceButtercrunchLivingston",
  "Lettuce Iceberg Livingston": "products.livingston.lettuceIcebergLivingston",
  "Spinach Bloomsdale Livingston": "products.livingston.spinachBloomsdaleLivingston",
  "Broccoli Calabrese Livingston": "products.livingston.broccoliCalabreseLivingston",
  "Cauliflower Snowball Livingston": "products.livingston.cauliflowerSnowballLivingston",
  "Cabbage Golden Acre Livingston": "products.livingston.cabbageGoldenAcreLivingston",

  // Flower Products
  "Marigold French": "products.flower.marigoldFrench",
  "Marigold African": "products.flower.marigoldAfrican",
  "Petunia Grandiflora": "products.flower.petuniaGrandiflora",
  "Petunia Multiflora": "products.flower.petuniaMultiflora",
  "Zinnia Giant": "products.flower.zinniaGiant",
  "Zinnia Dwarf": "products.flower.zinniaDwarf",
  "Cosmos Sensation": "products.flower.cosmosSensation",
  "Cosmos Dwarf": "products.flower.cosmosDwarf",
  "Nasturtium Climbing": "products.flower.nasturtiumClimbing",
  "Nasturtium Dwarf": "products.flower.nasturtiumDwarf",
  "Sunflower Giant": "products.flower.sunflowerGiant",
  "Sunflower Dwarf": "products.flower.sunflowerDwarf",
  "Pansy Large Flowered": "products.flower.pansyLargeFlowered",
  "Pansy Multiflora": "products.flower.pansyMultiflora",
  "Snapdragon Tall": "products.flower.snapdragonTall",
  "Snapdragon Dwarf": "products.flower.snapdragonDwarf",
  "Sweet Pea Spencer": "products.flower.sweetPeaSpencer",
  "Sweet Pea Dwarf": "products.flower.sweetPeaDwarf",
  "Calendula": "products.flower.calendula",
  "Lobelia": "products.flower.lobelia",

  // Vegetable Products
  "Tomato Beefsteak Vegetable": "products.vegetable.tomatoBeefsteakVeg",
  "Tomato Cherry Vegetable": "products.vegetable.tomatoCherryVeg",
  "Tomato Roma Vegetable": "products.vegetable.tomatoRomaVeg",
  "Pepper Bell Red Vegetable": "products.vegetable.pepperBellRedVeg",
  "Pepper Bell Yellow Vegetable": "products.vegetable.pepperBellYellowVeg",
  "Pepper Bell Green Vegetable": "products.vegetable.pepperBellGreenVeg",
  "Cucumber Marketmore Vegetable": "products.vegetable.cucumberMarketmoreVeg",
  "Cucumber Bush Pickle Vegetable": "products.vegetable.cucumberBushPickleVeg",
  "Corn Golden Bantam Vegetable": "products.vegetable.cornGoldenBantamVeg",
  "Corn Silver Queen Vegetable": "products.vegetable.cornSilverQueenVeg",
  "Bean Bush Blue Lake Vegetable": "products.vegetable.beanBushBlueLakeVeg",
  "Bean Pole Kentucky Wonder Vegetable": "products.vegetable.beanPoleKentuckyWonderVeg",
  "Carrot Danvers Half Long Vegetable": "products.vegetable.carrotDanversHalfLongVeg",
  "Carrot Nantes Coreless Vegetable": "products.vegetable.carrotNantesCorelessVeg",
  "Lettuce Buttercrunch Vegetable": "products.vegetable.lettuceButtercrunchVeg",
  "Lettuce Iceberg Vegetable": "products.vegetable.lettuceIcebergVeg",
  "Spinach Bloomsdale Vegetable": "products.vegetable.spinachBloomsdaleVeg",
  "Broccoli Calabrese Vegetable": "products.vegetable.broccoliCalabreseVeg",
  "Cauliflower Snowball Vegetable": "products.vegetable.cauliflowerSnowballVeg",
  "Cabbage Golden Acre Vegetable": "products.vegetable.cabbageGoldenAcreVeg"
,
  "(A) Alyssum Carpet of Snow": "products.flower.alyssumCarpetOfSnow",
  "(A) Aster Early Charm": "products.flower.asterEarlyCharm",
  "(A) Aster Powder Puffs": "products.flower.asterPowderPuffs",
  "(A) Baby's Breath Gypsophila Elegans": "products.flower.babysBreathGypsophilaElegans",
  "(A) Bachelor Buttons Fantastic Mix": "products.flower.bachelorButtonsFantasticMix",
  "(A) Bean Flowering Vine Scarlet Runner": "products.flower.beanFloweringVineScarletRunner",
  "(A) Black Eyed Susan Vine Thunbergia": "products.flower.blackEyedSusanVineThunbergia",
  "(A) Calendula Neon": "products.flower.calendulaNeon",
  "(A) Calendula Pacific Beauty Mix": "products.flower.calendulaPacificBeautyMix",
  "(A) Chrysanthemum Bright Eye": "products.flower.chrysanthemumBrightEye",
  "(A) Coleus Rainbow Mix": "products.flower.coleusRainbowMix",
  "(A) Cosmos Candy Stripe Kids": "products.flower.cosmosCandyStripeKids",
  "(A) Cosmos Double Click": "products.flower.cosmosDoubleClick",
  "(A) Cosmos Early Sensation Mix": "products.flower.cosmosEarlySensationMix",
  "(A) Cypress Vine White": "products.flower.cypressVineWhite",
  "(A) Dianthus Maiden Pink": "products.flower.dianthusMaidenPink",
  "(A) Flower Garden Old Fashioned": "products.flower.flowerGardenOldFashioned",
  "(A) Forget-Me-Not Cynoglossum": "products.flower.forgetmenotCynoglossum",
  "(A) Four O'Clock Mix": "products.flower.fourOclockMix",
  "(A) Gaillardia Grandiflora Mix": "products.flower.gaillardiaGrandifloraMix",
  "(A) Impatiens Tropical Fizz Hybrid": "products.flower.impatiensTropicalFizzHybrid",
  "(A) Lavatera Silvercup": "products.flower.lavateraSilvercup",
  "(A) Lavatera Twins Hot Pink": "products.flower.lavateraTwinsHotPink",
  "(A) Lobelia Crystal Palace": "products.flower.lobeliaCrystalPalace",
  "(A) Marigold Crackerjack": "products.flower.marigoldCrackerjack",
  "(A) Marigold Eskimo": "products.flower.marigoldEskimo",
  "(A) Marigold French Double Dwarf": "products.flower.marigoldFrenchDoubleDwarf",
  "(A) Marigold Hero Mix": "products.flower.marigoldHeroMix",
  "(A) Milkweed Butterfly": "products.flower.milkweedButterfly",
  "(A) Moonflower": "products.flower.moonflower",
  "(A) Morning Glory Early Call Mixed": "products.flower.morningGloryEarlyCallMixed",
  "(A) Morning Glory Flying Saucers": "products.flower.morningGloryFlyingSaucers",
  "(A) Morning Glory Heavenly Blue": "products.flower.morningGloryHeavenlyBlue",
  "(A) Morning Glory Mix": "products.flower.morningGloryMix",
  "(A) Nasturtium Alaska Mixed": "products.flower.nasturtiumAlaskaMixed",
  "(A) Nasturtium Dwarf Double Cherry Rose": "products.flower.nasturtiumDwarfDoubleCherryRose",
  "(A) Nasturtium Empress of India": "products.flower.nasturtiumEmpressOfIndia",
  "(A) Nasturtium Jewel Mixed": "products.flower.nasturtiumJewelMixed",
  "(A) Nasturtium Jewel mixed": "products.flower.nasturtiumJewelMixed",
  "(A) Nasturtium Night & Day": "products.flower.nasturtiumNightandday",
  "(A) Nasturtium Tall Climbing Mix": "products.flower.nasturtiumTallClimbingMix",
  "(A) Nemophilla Penny Black": "products.flower.nemophillaPennyBlack",
  "(A) Old Fashioned Flower Garden": "products.flower.oldFashionedFlowerGarden",
  "(A) Orn Corn Japan Stars & Stripes": "products.flower.ornCornJapanStarsandstripes",
  "(A) Pampas Grass Pink OG": "products.flower.pampasGrassPinkOg",
  "(A) Petunia Dwarf Bedding Mix": "products.flower.petuniaDwarfBeddingMix",
  "(A) Phlox Dwarf Beauty Mixture": "products.flower.phloxDwarfBeautyMixture",
  "(A) Poppy Falling In Love": "products.flower.poppyFallingInLove",
  "(A) Poppy Flanders Field": "products.flower.poppyFlandersField",
  "(A) Snapdragon Mini Snap Mix": "products.flower.snapdragonMiniSnapMix",
  "(A) Stocks Night Scented (Matthiola)": "products.flower.stocksNightScentedMatthiola",
  "(A) Sunflower Autumn Beauty": "products.flower.sunflowerAutumnBeauty",
  "(A) Sunflower Evening Sun": "products.flower.sunflowerEveningSun",
  "(A) Sunflower Golden Hedge": "products.flower.sunflowerGoldenHedge",
  "(A) Sunflower Henri Wilde": "products.flower.sunflowerHenriWilde",
  "(A) Sunflower Large Seeded Tall": "products.flower.sunflowerLargeSeededTall",
  "(A) Sunflower Lemon Queen": "products.flower.sunflowerLemonQueen",
  "(A) Sunflower Munchkin Kids": "products.flower.sunflowerMunchkinKids",
  "(A) Sunflower Paquito": "products.flower.sunflowerPaquito",
  "(A) Sunflower Red Sun": "products.flower.sunflowerRedSun",
  "(A) Sunflower Sunspot": "products.flower.sunflowerSunspot",
  "(A) Sunflower Taiyo": "products.flower.sunflowerTaiyo",
  "(A) Sunflower Vanilla Ice Cream": "products.flower.sunflowerVanillaIceCream",
  "(A) Sunflower Velvet Queen": "products.flower.sunflowerVelvetQueen",
  "(A) Sweet Pea Cupani": "products.flower.sweetPeaCupani",
  "(A) Sweet Pea Knee Hi": "products.flower.sweetPeaKneeHi",
  "(A) Sweet Pea Little Sweetheart Mix": "products.flower.sweetPeaLittleSweetheartMix",
  "(A) Sweet Pea Mix Starry Night": "products.flower.sweetPeaMixStarryNight",
  "(A) Sweet Pea Ocean Foam": "products.flower.sweetPeaOceanFoam",
  "(A) Sweet Pea Spencer Giant Mixture": "products.flower.sweetPeaSpencerGiantMixture",
  "(A) Sweet Pea Streamers Mix": "products.flower.sweetPeaStreamersMix",
  "(A) Sweet Pea Sugar and Spice": "products.flower.sweetPeaSugarAndSpice",
  "(A) Zinnia Berry Tart Mix": "products.flower.zinniaBerryTartMix",
  "(A) Zinnia California Dble Giant": "products.flower.zinniaCaliforniaDbleGiant",
  "(A) Zinnia Candy Cane": "products.flower.zinniaCandyCane",
  "(A) Zinnia Giant Cactus Flowered Mixture": "products.flower.zinniaGiantCactusFloweredMixture",
  "(A) Zinnia Tetra Flowered": "products.flower.zinniaTetraFlowered",
  "(B) Pansy Show Swiss Giant": "products.flower.pansyShowSwissGiant",
  "(B) Sweet William Mixed Colors": "products.flower.sweetWilliamMixedColors",
  "(P) Alyssum Saxatile": "products.flower.alyssumSaxatile",
  "(P) Aubretia Audrey Red Purple Mix": "products.flower.aubretiaAudreyRedPurpleMix",
  "(P) Canary Bird Vine": "products.flower.canaryBirdVine",
  "(P) Columbine Blue Star": "products.flower.columbineBlueStar",
  "(P) Columbine Long Spurred Mixed": "products.flower.columbineLongSpurredMixed",
  "(P) Cupids Dart": "products.flower.cupidsDart",
  "(P) Delphinium Pacific Giants": "products.flower.delphiniumPacificGiants",
  "(P) Dianthus Arctic Fire": "products.flower.dianthusArcticFire",
  "(P) Geum Red Dragon": "products.flower.geumRedDragon",
  "(P) Lupins Russell Mix": "products.flower.lupinsRussellMix",
  "(P) Malva Mystic Mixture": "products.flower.malvaMysticMixture",
  "(P) Malva Zebrina": "products.flower.malvaZebrina",
  "(P) Ornamental Grass Bunny Tails": "products.flower.ornamentalGrassBunnyTails",
  "(P) Poppy Iceland Mixed Colours": "products.flower.poppyIcelandMixedColours",
  "(P) Rudbeckia Goldsturm": "products.flower.rudbeckiaGoldsturm",
  "(P) Scabiosa Shepherds": "products.flower.scabiosaShepherds",
  "(P) Shasta Daisy Alaska": "products.flower.shastaDaisyAlaska",
  "(P) Soapwort Rock": "products.flower.soapwortRock",
  "(P) Sweet Pea Everlasting": "products.flower.sweetPeaEverlasting",
  "(W) Wildflower All Purpose Mixture": "products.flower.wildflowerAllPurposeMixture",
  "(W) Wildflower Bird & Butterfly Garden": "products.flower.wildflowerBirdandbutterflyGarden",
  "(W) Wildflower Black Eyed Susan": "products.flower.wildflowerBlackEyedSusan",
  "(W) Wildflower Hummingbird Gdn": "products.flower.wildflowerHummingbirdGdn",
  "Asparagus Viking": "products.vegetable.asparagusViking",
  "Aunt Molly's Ground Cherry": "products.vegetable.auntMollysGroundCherry",
  "Bachelor Button Choice": "products.livingston.bachelorButtonChoice",
  "Bean Amethyst Purple Filet(Bush)": "products.vegetable.beanAmethystPurpleFiletbush",
  "Bean Blue Lake (B)": "products.livingston.beanBlueLakeB",
  "Bean Blue Lake Stringless (P)": "products.livingston.beanBlueLakeStringlessP",
  "Bean Bountiful (B)": "products.livingston.beanBountifulB",
  "Bean Broad Windsor - H": "products.vegetable.beanBroadWindsorH",
  "Bean Bush Harvester Mangiatutto - H": "products.vegetable.beanBushHarvesterMangiatuttoH",
  "Bean Carson Bush": "products.vegetable.beanCarsonBush",
  "Bean Cherokee Wax (B)": "products.livingston.beanCherokeeWaxB",
  "Bean Contender - H": "products.vegetable.beanContenderH",
  "Bean Greencrop Bush - H": "products.vegetable.beanGreencropBushH",
  "Bean Kentucky Wonder (B)": "products.livingston.beanKentuckyWonderB",
  "Bean Kentucky Wonder Pole - H": "products.vegetable.beanKentuckyWonderPoleH",
  "Bean Kentucky Wonder Wax Pole - H": "products.vegetable.beanKentuckyWonderWaxPoleH",
  "Bean Neckargold Wax (Pole) - H": "products.vegetable.beanNeckargoldWaxPoleH",
  "Bean Pencil Pod Black Wax Bush - H": "products.vegetable.beanPencilPodBlackWaxBushH",
  "Bean Pole S Anna": "products.vegetable.beanPoleSAnna",
  "Bean Pole Smeraldo - H": "products.vegetable.beanPoleSmeraldoH",
  "Bean Pole Trionfo Violetta - H": "products.vegetable.beanPoleTrionfoViolettaH",
  "Bean Provider (B)": "products.livingston.beanProviderB",
  "Bean Romano (Bush) - H": "products.vegetable.beanRomanoBushH",
  "Bean Round Pod Kidney Wax Bush - H": "products.vegetable.beanRoundPodKidneyWaxBushH",
  "Bean Royal Burgundy Bush - H": "products.vegetable.beanRoyalBurgundyBushH",
  "Bean Scarlet Runner Pole - H": "products.vegetable.beanScarletRunnerPoleH",
  "Bean Stringless Green Pod Bush - H": "products.vegetable.beanStringlessGreenPodBushH",
  "Bean Tendergreen Improved Bush - H": "products.vegetable.beanTendergreenImprovedBushH",
  "Bean Topcrop (B)": "products.livingston.beanTopcropB",
  "Bean Velour Dwarf French Bush": "products.vegetable.beanVelourDwarfFrenchBush",
  "Beet Bull's Blood": "products.livingston.beetBullsBlood",
  "Beet Cylindra - H": "products.heritage.beetCylindraH",
  "Beet Cylindra Formanova - H": "products.vegetable.beetCylindraFormanovaH",
  "Beet Detroit Dark Red ST - H": "products.heritage.beetDetroitDarkRedStH",
  "Beet Early Wonder - H": "products.vegetable.beetEarlyWonderH",
  "Beet Golden Detroit - H": "products.vegetable.beetGoldenDetroitH",
  "Beet Ruby Queen - H": "products.vegetable.beetRubyQueenH",
  "Broccoli Decicco": "products.heritage.broccoliDecicco",
  "Broccoli Green Sprouting - H": "products.heritage.broccoliGreenSproutingH",
  "Broccoli Imperial": "products.vegetable.broccoliImperial",
  "Brussels Sprouts Catskill - H": "products.vegetable.brusselsSproutsCatskillH",
  "Cabbage Early Copenhagen Market - H": "products.vegetable.cabbageEarlyCopenhagenMarketH",
  "Cabbage Early Golden Acre": "products.heritage.cabbageEarlyGoldenAcre",
  "Cantaloupe Delicious - H": "products.vegetable.cantaloupeDeliciousH",
  "Cantaloupe Hearts Of Gold": "products.livingston.cantaloupeHeartsOfGold",
  "Cantaloupe Hearts of Gold - H": "products.heritage.cantaloupeHeartsOfGoldH",
  "Cantaloupe Minnesota Midget - H": "products.vegetable.cantaloupeMinnesotaMidgetH",
  "Cantaloupe Sierra Gold": "products.heritage.cantaloupeSierraGold",
  "Cardinal Climber": "products.livingston.cardinalClimber",
  "Carrot Chantenay": "products.heritage.carrotChantenay",
  "Carrot Danvers Half Long - H": "products.vegetable.carrotDanversHalfLongH",
  "Carrot Gigante Flakkee- H": "products.vegetable.carrotGiganteFlakkeeH",
  "Carrot Imperator": "products.heritage.carrotImperator",
  "Carrot Little Finger - H": "products.vegetable.carrotLittleFingerH",
  "Carrot Nantes Touchon - H": "products.vegetable.carrotNantesTouchonH",
  "Carrot Rainbow Mix": "products.vegetable.carrotRainbowMix",
  "Carrot Red Cored Chantenay": "products.heritage.carrotRedCoredChantenay",
  "Carrot Red Cored Chantenay - H": "products.vegetable.carrotRedCoredChantenayH",
  "Carrot Red Cored Chantenay ST - H": "products.heritage.carrotRedCoredChantenayStH",
  "Carrot Red Cored Danvers - H": "products.vegetable.carrotRedCoredDanversH",
  "Carrot Scarlet Nantes - H": "products.vegetable.carrotScarletNantesH",
  "Carrot Scarlet Nantes Coreless - H": "products.vegetable.carrotScarletNantesCorelessH",
  "Carrot Scarlet Nantes ST - H": "products.heritage.carrotScarletNantesStH",
  "Carrot Tenderlong Imperator - H": "products.vegetable.carrotTenderlongImperatorH",
  "Carrot Tendersweet Long Hybrid": "products.vegetable.carrotTendersweetLongHybrid",
  "Catgrass Oats": "products.vegetable.catgrassOats",
  "Cauliflower Early Snowball": "products.heritage.cauliflowerEarlySnowball",
  "Cauliflower Early Snowball - H": "products.vegetable.cauliflowerEarlySnowballH",
  "Celery Utah": "products.vegetable.celeryUtah",
  "Columbine McKana's Giant Mix": "products.livingston.columbineMckanasGiantMix",
  "Corn Bodacious": "products.vegetable.cornBodacious",
  "Corn Canadian Early Super Sweet": "products.vegetable.cornCanadianEarlySuperSweet",
  "Corn Double Sweet": "products.livingston.cornDoubleSweet",
  "Corn Early Sunglow": "products.vegetable.cornEarlySunglow",
  "Corn Golden Bantam - H": "products.vegetable.cornGoldenBantamH",
  "Corn Honey Select (Triple sweet)": "products.vegetable.cornHoneySelectTripleSweet",
  "Corn Honey and Cream Bicolor SU": "products.vegetable.cornHoneyAndCreamBicolorSu",
  "Corn Honey and CreamBicolour": "products.heritage.cornHoneyAndCreambicolour",
  "Corn Peaches and Cream Bicolour SU": "products.vegetable.cornPeachesAndCreamBicolourSu",
  "Cosmos Sensation Picotee": "products.livingston.cosmosSensationPicotee",
  "Cucumber Beit Alpha Burpless Lebanese": "products.vegetable.cucumberBeitAlphaBurplessLebanese",
  "Cucumber Corentine": "products.vegetable.cucumberCorentine",
  "Cucumber Earliest Mincu": "products.vegetable.cucumberEarliestMincu",
  "Cucumber Early Fortune": "products.livingston.cucumberEarlyFortune",
  "Cucumber Early Russian - H": "products.vegetable.cucumberEarlyRussianH",
  "Cucumber English Long Telegraph - H": "products.vegetable.cucumberEnglishLongTelegraphH",
  "Cucumber Homemade Pickles": "products.vegetable.cucumberHomemadePickles",
  "Cucumber Improved Long Green": "products.heritage.cucumberImprovedLongGreen",
  "Cucumber Long Green": "products.vegetable.cucumberLongGreen",
  "Cucumber Morden Early - H": "products.vegetable.cucumberMordenEarlyH",
  "Cucumber Muncher": "products.heritage.cucumberMuncher",
  "Cucumber Muncher Burpless": "products.livingston.cucumberMuncherBurpless",
  "Cucumber National Pickling - H": "products.vegetable.cucumberNationalPicklingH",
  "Cucumber National Pickling ST - H": "products.heritage.cucumberNationalPicklingStH",
  "Cucumber Spacemaster": "products.heritage.cucumberSpacemaster",
  "Cucumber Spacemaster Trailing - H": "products.vegetable.cucumberSpacemasterTrailingH",
  "Cucumber Spring Burpless": "products.vegetable.cucumberSpringBurpless",
  "Cucumber Straight Eight - H": "products.vegetable.cucumberStraightEightH",
  "Cucumber Sumter": "products.heritage.cucumberSumter",
  "Cucumber Tasty Green": "products.vegetable.cucumberTastyGreen",
  "Cucumber Tendergreen": "products.heritage.cucumberTendergreen",
  "Delphinium Pacific Giants Mix": "products.livingston.delphiniumPacificGiantsMix",
  "Echinicea Coneflower Purple": "products.livingston.echiniceaConeflowerPurple",
  "Eggplant Black Beauty - H": "products.vegetable.eggplantBlackBeautyH",
  "Endive Full Heart Batavian": "products.vegetable.endiveFullHeartBatavian",
  "Herb Arugula - H": "products.heritage.herbArugulaH",
  "Herb Arugula- H": "products.vegetable.herbArugulaH",
  "Herb Basil Cinnamon": "products.vegetable.herbBasilCinnamon",
  "Herb Basil Dark Opal": "products.heritage.herbBasilDarkOpal",
  "Herb Basil Genovese": "products.livingston.herbBasilGenovese",
  "Herb Basil Lemon": "products.vegetable.herbBasilLemon",
  "Herb Basil Lettuce Leaf - H": "products.vegetable.herbBasilLettuceLeafH",
  "Herb Basil Sweet - H": "products.vegetable.herbBasilSweetH",
  "Herb Basil Thai": "products.vegetable.herbBasilThai",
  "Herb Catnip - H": "products.vegetable.herbCatnipH",
  "Herb Chamomile - H": "products.vegetable.herbChamomileH",
  "Herb Chives - H": "products.vegetable.herbChivesH",
  "Herb Cilantro - H": "products.heritage.herbCilantroH",
  "Herb Cilantro Coriander - H": "products.vegetable.herbCilantroCorianderH",
  "Herb Cilantro La Reina Baja- H": "products.vegetable.herbCilantroLaReinaBajaH",
  "Herb Dill - H": "products.heritage.herbDillH",
  "Herb Dill Bouquet - H": "products.vegetable.herbDillBouquetH",
  "Herb Dill Fernleaf - H": "products.vegetable.herbDillFernleafH",
  "Herb Dill Mammoth": "products.livingston.herbDillMammoth",
  "Herb Garlic Chives - H": "products.vegetable.herbGarlicChivesH",
  "Herb Lavender - H": "products.vegetable.herbLavenderH",
  "Herb Lemon Balm": "products.vegetable.herbLemonBalm",
  "Herb Mint": "products.vegetable.herbMint",
  "Herb Oregano": "products.heritage.herbOregano",
  "Herb Oregano - H": "products.vegetable.herbOreganoH",
  "Herb Parsley Italian Dark Green": "products.heritage.herbParsleyItalianDarkGreen",
  "Herb Parsley Moss Curled": "products.vegetable.herbParsleyMossCurled",
  "Herb Parsley Single Hardy Italian": "products.vegetable.herbParsleySingleHardyItalian",
  "Herb Peppermint": "products.vegetable.herbPeppermint",
  "Herb Rosemary - H": "products.vegetable.herbRosemaryH",
  "Herb Sage": "products.heritage.herbSage",
  "Herb Sage - H": "products.vegetable.herbSageH",
  "Herb Spearmint": "products.vegetable.herbSpearmint",
  "Herb Summer Savory - H": "products.vegetable.herbSummerSavoryH",
  "Herb Tarragon - H": "products.vegetable.herbTarragonH",
  "Herb Thyme - H": "products.vegetable.herbThymeH",
  "Honey Dew Green Flesh - H": "products.vegetable.honeyDewGreenFleshH",
  "Kale Dwarf Green Curled - H": "products.vegetable.kaleDwarfGreenCurledH",
  "Kale Lacinato - H": "products.vegetable.kaleLacinatoH",
  "Kale Red Russian - H": "products.vegetable.kaleRedRussianH",
  "Kale Siberian": "products.heritage.kaleSiberian",
  "Kohi Rabi White Vienna": "products.heritage.kohiRabiWhiteVienna",
  "Kohl Rabi Early White Vienna - H": "products.vegetable.kohlRabiEarlyWhiteViennaH",
  "Larkspur Giant Imperial": "products.livingston.larkspurGiantImperial",
  "Leek Monstrous Carentan - H": "products.vegetable.leekMonstrousCarentanH",
  "Lettuce Baby Romaine": "products.livingston.lettuceBabyRomaine",
  "Lettuce Bibb": "products.livingston.lettuceBibb",
  "Lettuce Black Seeded Simpson": "products.heritage.lettuceBlackSeededSimpson",
  "Lettuce Buttercrunch - H": "products.vegetable.lettuceButtercrunchH",
  "Lettuce Cos or Romaine ST - H": "products.heritage.lettuceCosOrRomaineStH",
  "Lettuce Early Curled Simpson - H": "products.vegetable.lettuceEarlyCurledSimpsonH",
  "Lettuce Early Great Lakes - H": "products.vegetable.lettuceEarlyGreatLakesH",
  "Lettuce Grand Rapids - H": "products.vegetable.lettuceGrandRapidsH",
  "Lettuce Grand Rapids ST - H": "products.heritage.lettuceGrandRapidsStH",
  "Lettuce Iceberg - H": "products.vegetable.lettuceIcebergH",
  "Lettuce Livingston's Mix": "products.livingston.lettuceLivingstonsMix",
  "Lettuce Prizehead - H": "products.vegetable.lettucePrizeheadH",
  "Lettuce Red Sails": "products.heritage.lettuceRedSails",
  "Lettuce Red Salad Bowl - H": "products.vegetable.lettuceRedSaladBowlH",
  "Lettuce Romaine - H": "products.vegetable.lettuceRomaineH",
  "Lettuce Salad Bowl": "products.heritage.lettuceSaladBowl",
  "Lettuce Select Salad Blend": "products.livingston.lettuceSelectSaladBlend",
  "Lettuce Slobolt": "products.livingston.lettuceSlobolt",
  "Lettuce Tennis Ball": "products.livingston.lettuceTennisBall",
  "Marigold Petite": "products.livingston.marigoldPetite",
  "Mesclun Gourmet Greens Mix": "products.vegetable.mesclunGourmetGreensMix",
  "Mesclun Gourmet Greens Mixture": "products.heritage.mesclunGourmetGreensMixture",
  "Mesclun Salad Mix": "products.heritage.mesclunSaladMix",
  "Morning Glory Blue Picotee": "products.livingston.morningGloryBluePicotee",
  "Morning Glory Choice": "products.livingston.morningGloryChoice",
  "Okra Clemson Spineless": "products.vegetable.okraClemsonSpineless",
  "Onion Annual Bunching": "products.vegetable.onionAnnualBunching",
  "Onion Candy": "products.vegetable.onionCandy",
  "Onion Evergreen Bunching": "products.heritage.onionEvergreenBunching",
  "Onion Red Wethersfield": "products.livingston.onionRedWethersfield",
  "Onion Rossa Lunga di Firenze": "products.vegetable.onionRossaLungaDiFirenze",
  "Onion White Lisbon Bunching": "products.livingston.onionWhiteLisbonBunching",
  "Onion White Lisbon Bunching ST": "products.heritage.onionWhiteLisbonBunchingSt",
  "Pak Choi Mei Qing": "products.vegetable.pakChoiMeiQing",
  "Parsnip Hollow Crown - H": "products.vegetable.parsnipHollowCrownH",
  "Pea Alaska - H": "products.vegetable.peaAlaskaH",
  "Pea Cascadia (Sugar Snap)": "products.vegetable.peaCascadiaSugarSnap",
  "Pea Dwarf Grey Sugar": "products.livingston.peaDwarfGreySugar",
  "Pea Early Frosty": "products.livingston.peaEarlyFrosty",
  "Pea Edible Podded Snow - H": "products.vegetable.peaEdiblePoddedSnowH",
  "Pea Green Arrow - H": "products.vegetable.peaGreenArrowH",
  "Pea Laxton's Progress - H": "products.vegetable.peaLaxtonsProgressH",
  "Pea Laxtons Progress - H": "products.heritage.peaLaxtonsProgressH",
  "Pea Lincoln Homesteader - H": "products.vegetable.peaLincolnHomesteaderH",
  "Pea Little Marvel - H": "products.vegetable.peaLittleMarvelH",
  "Pea Mr Big": "products.vegetable.peaMrBig",
  "Pea Oregon Sugar Pod": "products.heritage.peaOregonSugarPod",
  "Pea Oregon Sugar Pod II": "products.livingston.peaOregonSugarPodIi",
  "Pea Snowpea Snowflake": "products.vegetable.peaSnowpeaSnowflake",
  "Pea Sugar Daddy": "products.heritage.peaSugarDaddy",
  "Pea Sugar Snap - H": "products.heritage.peaSugarSnapH",
  "Pea Sugar Snap Edible Pod - H": "products.vegetable.peaSugarSnapEdiblePodH",
  "Pea Tall Telephone - H": "products.vegetable.peaTallTelephoneH",
  "Pea Tom Thumb - H": "products.heritage.peaTomThumbH",
  "Peas Sugar Sprint Edible Pod": "products.vegetable.peasSugarSprintEdiblePod",
  "Pepper Bell Color Mix": "products.livingston.pepperBellColorMix",
  "Pepper California Wonder - H": "products.heritage.pepperCaliforniaWonderH",
  "Pepper Early California Wonder - H": "products.vegetable.pepperEarlyCaliforniaWonderH",
  "Pepper Golden California Wonder - H": "products.heritage.pepperGoldenCaliforniaWonderH",
  "Pepper Hungarian Yellow Hot": "products.vegetable.pepperHungarianYellowHot",
  "Pepper King Of The North": "products.livingston.pepperKingOfTheNorth",
  "Pepper Long Red Cayenne Slim": "products.heritage.pepperLongRedCayenneSlim",
  "Pepper Mini Bell Mixed": "products.vegetable.pepperMiniBellMixed",
  "Pepper Piccante De Cayenna": "products.vegetable.pepperPiccanteDeCayenna",
  "Pepper Rainbow Blend": "products.heritage.pepperRainbowBlend",
  "Pepper Red Bell": "products.vegetable.pepperRedBell",
  "Pepper Super Chili Hybrid": "products.vegetable.pepperSuperChiliHybrid",
  "Pepper Sweet Banana": "products.heritage.pepperSweetBanana",
  "Pepper Wicked Ghost": "products.vegetable.pepperWickedGhost",
  "Poppy Oriental Red": "products.livingston.poppyOrientalRed",
  "Pumpkin Big Max": "products.heritage.pumpkinBigMax",
  "Pumpkin Big Moon": "products.livingston.pumpkinBigMoon",
  "Pumpkin Dills Atlantic Giant PVP": "products.vegetable.pumpkinDillsAtlanticGiantPvp",
  "Pumpkin EZ Gro Monster": "products.vegetable.pumpkinEzGroMonster",
  "Pumpkin Jack O'Lantern": "products.vegetable.pumpkinJackOlantern",
  "Pumpkin Jack-Be-Little": "products.livingston.pumpkinJackbelittle",
  "Pumpkin Livingston's Pie": "products.livingston.pumpkinLivingstonsPie",
  "Pumpkin Small Sugar": "products.heritage.pumpkinSmallSugar",
  "Pumpkin Small Sugar - H": "products.vegetable.pumpkinSmallSugarH",
  "Radish Cherry Belle": "products.heritage.radishCherryBelle",
  "Radish Cherry Belle - H": "products.vegetable.radishCherryBelleH",
  "Radish Crimson Giant Champion - H": "products.vegetable.radishCrimsonGiantChampionH",
  "Radish Easter Egg Blend": "products.heritage.radishEasterEggBlend",
  "Radish French Breakfast": "products.heritage.radishFrenchBreakfast",
  "Radish French Breakfast - H": "products.vegetable.radishFrenchBreakfastH",
  "Radish German Giant - H": "products.vegetable.radishGermanGiantH",
  "Radish Gourmet Blend": "products.vegetable.radishGourmetBlend",
  "Radish Scarlet Globe - H": "products.vegetable.radishScarletGlobeH",
  "Radish Sparkler White Tip": "products.heritage.radishSparklerWhiteTip",
  "Radish Sparkler White Tip - H": "products.vegetable.radishSparklerWhiteTipH",
  "Radish Watermelon": "products.vegetable.radishWatermelon",
  "Rutabaga Swede Laurentian - H": "products.vegetable.rutabagaSwedeLaurentianH",
  "Rutabega American Purple Top - H": "products.vegetable.rutabegaAmericanPurpleTopH",
  "Spinach America": "products.livingston.spinachAmerica",
  "Spinach Bloomsdale Long Standing": "products.heritage.spinachBloomsdaleLongStanding",
  "Spinach Giant Noble - H": "products.vegetable.spinachGiantNobleH",
  "Spinach King Of Denmark - H": "products.vegetable.spinachKingOfDenmarkH",
  "Spinach Long Standing Bloomsdale": "products.heritage.spinachLongStandingBloomsdale",
  "Spinach Long Standing Bloomsdale - H": "products.vegetable.spinachLongStandingBloomsdaleH",
  "Spinach New Zealand - H": "products.vegetable.spinachNewZealandH",
  "Spinach Perpetual - H": "products.vegetable.spinachPerpetualH",
  "Spinach Viroflay": "products.heritage.spinachViroflay",
  "Squash Buttercup": "products.vegetable.squashButtercup",
  "Squash Cocozelle": "products.livingston.squashCocozelle",
  "Squash Early Bush Scallop": "products.heritage.squashEarlyBushScallop",
  "Squash Early Prolific Straighneck - H": "products.heritage.squashEarlyProlificStraighneckH",
  "Squash Table King Acorn": "products.livingston.squashTableKingAcorn",
  "Squash Table Queen": "products.heritage.squashTableQueen",
  "Squash Table Queen - H": "products.vegetable.squashTableQueenH",
  "Squash Vegetable Spaghetti - H": "products.vegetable.squashVegetableSpaghettiH",
  "Swiss Chard Bright Lights": "products.vegetable.swissChardBrightLights",
  "Swiss Chard Fordhook - H": "products.heritage.swissChardFordhookH",
  "Swiss Chard Fordhook Giant - H": "products.vegetable.swissChardFordhookGiantH",
  "Swiss Chard Rainbow Blend": "products.heritage.swissChardRainbowBlend",
  "Swiss Chard Rhubarb - H": "products.vegetable.swissChardRhubarbH",
  "Swiss Chard Ruby Red": "products.heritage.swissChardRubyRed",
  "Swiss Chard Ruby Red - H": "products.vegetable.swissChardRubyRedH",
  "Tomato Abe Lincoln": "products.livingston.tomatoAbeLincoln",
  "Tomato Baby Roma": "products.livingston.tomatoBabyRoma",
  "Tomato Beefsteak Bush - H": "products.vegetable.tomatoBeefsteakBushH",
  "Tomato Bonny Best - H": "products.vegetable.tomatoBonnyBestH",
  "Tomato Brandywine Red": "products.livingston.tomatoBrandywineRed",
  "Tomato Brandywine Red - H": "products.heritage.tomatoBrandywineRedH",
  "Tomato Cherry Mix F1": "products.vegetable.tomatoCherryMixF1",
  "Tomato Cherry Roma": "products.vegetable.tomatoCherryRoma",
  "Tomato Chocolate Cherry- H": "products.vegetable.tomatoChocolateCherryH",
  "Tomato Delicious": "products.heritage.tomatoDelicious",
  "Tomato Early Girl": "products.vegetable.tomatoEarlyGirl",
  "Tomato Jubilee- H": "products.vegetable.tomatoJubileeH",
  "Tomato Manitoba - H": "products.vegetable.tomatoManitobaH",
  "Tomato Marglobe": "products.livingston.tomatoMarglobe",
  "Tomato Rainbow Blend - H": "products.vegetable.tomatoRainbowBlendH",
  "Tomato Rainbow Cherry": "products.heritage.tomatoRainbowCherry",
  "Tomato Red Cherry Large": "products.livingston.tomatoRedCherryLarge",
  "Tomato Roma - H": "products.heritage.tomatoRomaH",
  "Tomato Roma VF - H": "products.vegetable.tomatoRomaVfH",
  "Tomato San Marzano": "products.vegetable.tomatoSanMarzano",
  "Tomato Sub Arctic Plenty - H": "products.vegetable.tomatoSubArcticPlentyH",
  "Tomato Super Sweet": "products.vegetable.tomatoSuperSweet",
  "Tomato Sweetie": "products.heritage.tomatoSweetie",
  "Tomato Tiny Tim - H": "products.vegetable.tomatoTinyTimH",
  "Tomato Yellow Pearshaped": "products.vegetable.tomatoYellowPearshaped",
  "Turnip Purple Top": "products.heritage.turnipPurpleTop",
  "Turnip Purple Top White Globe - H": "products.vegetable.turnipPurpleTopWhiteGlobeH",
  "Viola Johnny Jump Up": "products.livingston.violaJohnnyJumpUp",
  "Watermelon Black Diamond": "products.livingston.watermelonBlackDiamond",
  "Watermelon Crimson Sweet": "products.vegetable.watermelonCrimsonSweet",
  "Watermelon Dixie Queen": "products.livingston.watermelonDixieQueen",
  "Watermelon Early Canada Improved - H": "products.vegetable.watermelonEarlyCanadaImprovedH",
  "Watermelon Garden Leader Monster": "products.vegetable.watermelonGardenLeaderMonster",
  "Watermelon Moon & Stars Red": "products.livingston.watermelonMoonandstarsRed",
  "Watermelon Petite Yellow": "products.vegetable.watermelonPetiteYellow",
  "Watermelon Sugar Baby": "products.heritage.watermelonSugarBaby",
  "Watermelon Sugar Baby - H": "products.vegetable.watermelonSugarBabyH",
  "Zinnia Cut & Come Again": "products.livingston.zinniaCutandcomeAgain",
  "Zinnia Lilliput": "products.livingston.zinniaLilliput",
  "Zinnia State Fair": "products.livingston.zinniaStateFair",
  "Zucchini Alberello Di Sarzana": "products.vegetable.zucchiniAlberelloDiSarzana",
  "Zucchini Black Beauty": "products.livingston.zucchiniBlackBeauty",
  "Zucchini Black Beauty - H": "products.heritage.zucchiniBlackBeautyH",
  "Zucchini Bush": "products.livingston.zucchiniBush",
  "Zucchini Dark Green - H": "products.vegetable.zucchiniDarkGreenH",
  "Zucchini Elite Hybrid": "products.vegetable.zucchiniEliteHybrid",
  "Zucchini Foodhook": "products.heritage.zucchiniFoodhook",
  "Zucchini Gold Rush": "products.vegetable.zucchiniGoldRush"
};

// Category translation mapping
export const CATEGORY_TRANSLATION_KEYS: Record<string, string> = {
  "organic": "categories.organic",
  "seedtape": "categories.seedtape", 
  "heritage": "categories.heritage",
  "vegetable": "categories.vegetable",
  "flower": "categories.flower"
};

// Hook to get translated product name
export const useTranslatedProductName = (productName: string): string => {
  const { t } = useTranslation();
  const translationKey = PRODUCT_TRANSLATION_KEYS[productName];
  return translationKey ? t(translationKey) : productName;
};

// Hook to get translated category name
export const useTranslatedCategory = (category: string): string => {
  const { t } = useTranslation();
  const translationKey = CATEGORY_TRANSLATION_KEYS[category];
  return translationKey ? t(translationKey) : category;
};

// Utility function to get translated product name without hook
// If no translation key exists, returns the English product name (which is acceptable since data is stored in English)
export const getTranslatedProductName = (productName: string, t: (key: string) => string): string => {
  const translationKey = PRODUCT_TRANSLATION_KEYS[productName];
  if (translationKey) {
    const translated = t(translationKey);
    // If translation returns the key itself (meaning translation not found), fall back to English
    return translated === translationKey ? productName : translated;
  }
  // No translation key exists - return English name (data stored in English)
  return productName;
};

// Utility function to get translated category name without hook
export const getTranslatedCategory = (category: string, t: (key: string) => string): string => {
  const translationKey = CATEGORY_TRANSLATION_KEYS[category];
  return translationKey ? t(translationKey) : category;
};
